// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import {
  ArrowIcon,
  CaretDownIcon,
  CaretUpIcon,
  WarningIcon,
  XMarkIcon,
  CircleCheckSolidIcon,
} from "../../assets/svgs";
import { toast } from "react-toastify";
import { Storage } from "aws-amplify";
import { FullscreenOutlined, ZoomInOutlined } from "@ant-design/icons";
import {
  ApprovalStatus,
  Position,
  PositionImage,
  UploadStatus,
  UserOrder,
} from "../../interfaces";
import Modal from "../modal/Modal";
import Upload from "./Upload";
import {
  asyncForEach,
  getOutline,
  getRemainingColor,
  getRemainingCount,
  getRatio,
  resetInset,
} from "../../utils";
import RenderBackgroundLoader from "./RenderBackgroundLoader";
import ImageDetail from "./ImageDetail";
import SendPrintdata from "./SendPrintdata";
import { useTranslation } from "react-i18next";
import PdfPreview from "./PdfPreview";
import ImageGallery from "../image/ImageGallery";
import RenderDontApproveView from "../dashboard/RenderDontApproveView";
import ImagePreviewLoading from "../ImagePreviewLoading";
import RenderApproveView from "../dashboard/RenderApproveView";
import { Loader, Text } from "@mantine/core";
import ImageOutline from "../image/ImageOutline";
import { FileWithPath } from "@mantine/dropzone";
import useOrder from "../../hooks/useOrder";
import useHandleS3 from "../../hooks/useHandleS3";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import PageSelectionModal from "./PageSelectionModal";
import { RingProgress, Progress } from "@mantine/core";
import imageCompression from "browser-image-compression";
import jsPDF from "jspdf";
import { PDFDocument } from 'pdf-lib';  // Diese Library hinzufügen für echtes PDF-Splitting
// Placeholder image (could be a blank image, spinner, etc.)
const PLACEHOLDER_IMAGE = "data:image/png;base64,..."; // Add a placeholder image here

type Props = {
  item: Position;
  index: number;
  order: UserOrder;
  mutate: (state: UserOrder) => void;
  disabled?: boolean;
  send?: boolean;
  onImagesChange?: (images: PositionImage[], index: number) => void;
};

export interface RecentUrls {
  [key: string]: string;
}

const PositionItem: React.FC<Props> = ({
  item,
  index,
  order,
  mutate,
  disabled = false,
  send = false,
  onImagesChange,
}) => {
  const [pdfProgress, setPdfProgress] = useState<number | null>(null);
  const [singlePdfProgress, setSinglePdfProgress] = useState<number | null>(
    null
  );
  const [singleProgress, setSingleProgress] = useState<number | null>(null);
  const [progress, setProgress] = useState<number | null>(null);
  const [loadingCard, setLoadingCard] = useState<any | null>(null);
  const [imageProgress, setImageProgress] = useState<Record<string, number>>(
    {}
  );
  const [recentUrls, setRecentUrls] = useState<RecentUrls>({});
  const [signedUrls, setSignedUrls] = useState<any>({});
  const [url, setUrl] = useState<string | null>(null);
  const [open, setOpen] = useState(
    index === 0 || [...(item.positionImage || [])].length > 0 || false
  );
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [modalApproveVisible, setModalApproveVisible] =
    useState<boolean>(false);
  const [pageSelectionModalVisible, setPageSelectionModalVisible] =
    useState<boolean>(false);
  const [approved, setApproved] = useState<boolean>(false);
  const [type, setType] = useState<"image" | "pdf" | null>(null);
  const [outline, setOutline] = useState<string>();
  const [base64] = useState<string>();
  const [uploadStatus, setUploadStatus] = useState<UploadStatus | undefined>();
  const [galleryImage, setGalleryImage] = useState<string | null>(null);
  const [numPages, setNumPages] = useState<number>();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [images, setImages] = useState<PositionImage[]>(
    item.positionImage || []
  );
  const [current, setCurrent] = useState<PositionImage | null>(null);
  const [uploading, setUploading] = useState<boolean>(false);
  const [isLarge, setIsLarge] = useState<boolean>(false);
  const [, setPdfKey] = useState<string>();
  const [thumbnailGenerating, setThumbnailGenerating] =
    useState<boolean>(false);

  const [ratio, setRatio] = useState<{
    x: number;
    y: number;
    fit: boolean;
  }>();
  const [pdfPages, setPdfPages] = useState<
    {
      name: string;
      dimensions: string;
      url: string;
      fileName: string;
      fileSize: string;
      originalPdfPage: any;
    }[]
  >([]);
  const [selectedPages] = useState<string[]>([]);

  const { handleOrderUpdate } = useOrder();
  const { validateUpload, onComplete } = useHandleS3({ data: order });

  const handleUpload = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const onInputChange = async (
    files: FileList | FileWithPath[],
    indexNumber: any
  ) => {
    const file = files[0];

    if (!/png|jpeg|jpg|pdf/.test(file?.type)) {
      toast.warn(t("unsupportedFile"));
      return;
    }

    const validation = await validateUpload({
      file,
      intendedPositionIndex: indexNumber,
    });

    if (validation) {
      const { key, positionImage, positionIndex } = validation;
      setUploading(true); // Start the loader

      if (file.type === "application/pdf") {

        const { pageCount, pages } = await splitPdf(file);
        setPdfPages(pages);
        setNumPages(numPages);

        if (pageCount === 1) {
          try {
            setPdfProgress(null);
            await handleSinglePagePdfUpload(
              key,
              file,
              positionImage,
              positionIndex
            );
          } catch (error) {
            toast.error(t("fileUploadFailed"));
            console.error("File upload error:", error);
          }
        } else {
          setPdfProgress(100);
          setTimeout(() => {
            setPageSelectionModalVisible(true);
            setPdfProgress(null);
          }, 500);
        }
      } else {
        try {
          await handleImageUpload(key, file, positionImage, positionIndex);
        } catch (error) {
          toast.error(t("fileUploadFailed"));
          console.error("File upload error:", error);
        }
      }
    }
  };

  const getFileNames = (key: string, fileType: string) => {
    const baseName = key.split("/").pop() || "";
    const extension = fileType === "application/pdf" ? "pdf" : "png";
    const fileName = `${key}.${extension}`;
    const thumbnailFileName = `${key}-thumbnail.png`;
    return { fileName, thumbnailFileName };
  };

  const handleSinglePagePdfUpload = async (
    key: string,
    file: File,
    positionImage: PositionImage,
    positionIndex: number
  ) => {
    setSinglePdfProgress(1);
    let interval: NodeJS.Timeout | null = null;
    try {

      const [name, extension] = file?.name.split(/(?=\.[^.]+$)/);
      const fileNameMain = `${name}-${Date.now()}`;
      const fileName = `${order.id}/${fileNameMain}.pdf`;
      const thumbnailFileName = `${order.id}/${fileNameMain}-thumbnail.png`;
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      await Storage.put(fileName, file, {
        contentType: "application/pdf",
        progressCallback(progressEvent) {
          let progress = (progressEvent.loaded / progressEvent.total) * 100;

          setSinglePdfProgress(Math.round(progress));
        }
      });
      const pdf = await pdfjsLib.getDocument(URL.createObjectURL(file)).promise;
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 1 });
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: ctx,
        viewport: viewport,
      };
      await page.render(renderContext).promise;
      const dataUrl = canvas.toDataURL("image/png");

      const fullSizeBlob = await (await fetch(dataUrl)).blob();
      const lowResBlob = await createLowResolutionBlob(fullSizeBlob);
      await Storage.put(thumbnailFileName, lowResBlob, {
        contentType: "image/png",
      });

      const updatedPositionImage = {
        ...positionImage,
        key: fileName,
        pdfKey: fileName,
        thumbnail: thumbnailFileName,
      };
      const updatedOrder = await onComplete(
        updatedPositionImage,
        positionIndex
      );

      if (updatedOrder) {
        mutate(updatedOrder);
        setSignedUrls((prev: any) => ({
          ...prev,
          [fileName]: fileName,
        }));
        await fetchImage();
      }

      setSinglePdfProgress(null);
      toast.success(
        `${fileName.split("/").pop()} and ${thumbnailFileName
          .split("/")
          .pop()} uploaded successfully.`
      );
    } catch (error) {
      console.error("File upload error:", error);
      toast.error(`Failed to upload ${key.split("/").pop()}.`);
    } finally {
      if (interval) clearInterval(interval);
      setSinglePdfProgress(null);
    }
  };
  const blobToImage = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = reader.result;
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
  const createPDFBlob = async (imageBlob) => {
    const pdf = new jsPDF();
    try {
      const image = await blobToImage(imageBlob);
      const imgWidth = image.width;
      const imgHeight = image.height;
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const scaleWidth = pdfWidth / imgWidth;
      const scaleHeight = pdfHeight / imgHeight;
      const scale = Math.min(scaleWidth, scaleHeight);
      const x = (pdfWidth - imgWidth * scale) / 2;
      const y = (pdfHeight - imgHeight * scale) / 2;
      const width = imgWidth * scale;
      const height = imgHeight * scale;
      pdf.addImage(image, "PNG", x, y, width, height);
      return pdf.output("blob");
    } catch (error) {
      console.error("Error creating PDF blob:", error);
      throw error;
    }
  };

  const createLowResolutionBlob = async (fullSizeBlob: Blob): Promise<Blob> => {
    const image = await new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(fullSizeBlob);
      img.onload = () => resolve(img);
      img.onerror = reject;
    });

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const MAX_WIDTH = 400;
    const MAX_HEIGHT = 300;

    let width = image.width;
    let height = image.height;

    if (width > height) {
      if (width > MAX_WIDTH) {
        height *= MAX_WIDTH / width;
        width = MAX_WIDTH;
      }
    } else {
      if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height;
        height = MAX_HEIGHT;
      }
    }

    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(image, 0, 0, width, height);

    return new Promise<Blob>((resolve) =>
      canvas.toBlob(resolve, "image/png", 0.5)
    );
  };

  const handleImageUpload = async (
    key: string,
    file: File,
    positionImage: PositionImage,
    positionIndex: number
  ) => {
    setSingleProgress(10);
    setSignedUrls((prev: any) => ({
      ...prev,
      [key]: PLACEHOLDER_IMAGE,
    }));

    try {
      const image = await new Promise<HTMLImageElement>((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => resolve(img);
        img.onerror = reject;
      });

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        throw new Error("Failed to get canvas context");
      }

      const MAX_WIDTH = 400;
      const MAX_HEIGHT = 300;

      let width = image.width;
      let height = image.height;

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(image, 0, 0, width, height);

      const lowResBlob = await new Promise<Blob>((resolve, reject) =>
        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error("Failed to create blob from canvas"));
            }
          },
          "image/png",
          0.5
        )
      );

      if (lowResBlob) {
        console.log(
          `Low-resolution thumbnail file size: ${lowResBlob.size / 1024} KB`
        );
      }

      const [name, extension] = file?.name.split(/(?=\.[^.]+$)/);
      const fileNameMain = `${name}-${Date.now()}`;
      const fileName = `${order.id}/${fileNameMain}${extension}`;
      const thumbnailFileName = `${order.id}/${fileNameMain}-thumbnail.png`;

      let uploadProgress = 0;
      const interval = setInterval(() => {
        uploadProgress += 10;
        if (uploadProgress >= 100) {
          clearInterval(interval);
          uploadProgress = 100;
        }
        setSingleProgress(uploadProgress);
      }, 200);

      await Storage.put(fileName, file, {
        contentType: file.type,
      });

      await Storage.put(thumbnailFileName, lowResBlob, {
        contentType: "image/png",
      });

      clearInterval(interval);
      setSingleProgress(100);

      const updatedPositionImage = {
        ...positionImage,
        key: fileName,
        thumbnail: thumbnailFileName,
      };
      const updatedOrder = await onComplete(
        updatedPositionImage,
        positionIndex
      );

      if (updatedOrder) {
        mutate(updatedOrder);
        setSignedUrls((prev: any) => ({
          ...prev,
          [thumbnailFileName]: thumbnailFileName,
        }));
        await fetchImage();
      }
      setUploading(false);
      toast.success(t("fileUploadedSuccessfully"));
      setSingleProgress(null);
    } catch (error) {
      setUploading(false);
      toast.error(t("fileUploadFailed"));
      console.error("File upload error:", error);
      setSingleProgress(null);
    }
  };

  const fetchImage = async () => {
    if (!item?.positionImage || !Array.isArray(item.positionImage)) {
      setSignedUrls({});
      setImages([]);
      onImagesChange && onImagesChange([], index);
      return;
    }
    const urls: any = {};
    await asyncForEach(item.positionImage, async (position: PositionImage) => {
      if (position?.thumbnail) {
        const url: any = await Storage.get(position.thumbnail);
        urls[position.thumbnail] = url;
      }
    });

    setSignedUrls(urls);
    setImages(item.positionImage);
    onImagesChange && onImagesChange(item.positionImage, index);
  };

  useEffect(() => {
    fetchImage();
  }, [item.positionImage]);

  const galleryPreview = (imgUrl?: string) => {
    if (imgUrl) {
      setGalleryImage(imgUrl);
    } else {
      const preview = document.getElementById(
        `image-preview_${index}`
      ) as HTMLImageElement;
      if (preview) setGalleryImage(preview.src);
    }
  };

  const loadPdf = async (key: string) => {
    if (recentUrls[key]) {
      setUrl(recentUrls[key]);
      onModalOpen();
      return;
    }

    const signedUrl = await Storage.get(key);
    setRecentUrls({ ...recentUrls, [key]: signedUrl });
    setUrl(signedUrl);
    onModalOpen();
  };

  const handleQuantityChange = (newQuantity: number) => {
    if (newQuantity >= 1 && sum + (newQuantity - quantity) <= item.quantity) {
      const updatedImages = images.map((img, idx) =>
        idx === index ? { ...img, quantity: newQuantity } : img
      );
      setImages(updatedImages);
      const positions = order.positions.map((position, posIndex) => {
        if (
          position.articleNumber === item.articleNumber &&
          position.heightByMm === item.heightByMm &&
          position.widthByMm === item.widthByMm &&
          posIndex === idx
        ) {
          return {
            ...position,
            positionImage: updatedImages,
          };
        }
        return position;
      });

      const updatedOrder = { ...order, positions };

      toast.success(t("quantityUpdated"));
      handleOrderUpdate({ id: order.id, positions });
      mutate(updatedOrder);
    }
  };

  const loadImage = async (key: string) => {
    if (recentUrls[key]) {
      setUrl(recentUrls[key]);
      onModalOpen();
      return;
    }

    const signedUrl = await Storage.get(key);
    setRecentUrls({ ...recentUrls, [key]: signedUrl });
    setUrl(signedUrl);
    onModalOpen();
  };

  const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setOutline(getOutline({ image: e.currentTarget, item }));
    setUploading(false); // Stop the loader once the image is loaded
  };

  const onModalApproveClose = () => {
    setModalApproveVisible(false);
    setCurrent(null);
  };

  const onModalOpen = () => {
    setModalVisible(true);
  };

  const onModalClose = () => {
    resetState();

    const preview = document.getElementById(
      `image-preview_${index}`
    ) as HTMLImageElement;
    setTimeout(() => {
      setCurrent(null);
      setType(null);
      if (preview) preview.src = "";
    }, 300);
  };

  const grantReleaseCallback = (_order: UserOrder) => {
    onModalApproveClose();
    setImages(_order.positions[index].positionImage || []);
    mutate(_order);
  };

  const resetState = () => {
    setModalVisible(false);
    setApproved(false);
    setUploadStatus(undefined);
    setPdfKey(undefined);
    setIsLarge(false);
    setTimeout(() => {
      setCurrent(null);
      setUrl(null);
      setOutline(undefined);
      setNumPages(0);
      setRatio(undefined);
      resetInset(index);
    }, 300);
  };


  // Modifizierte handleUploadSelectedPages Funktion
  const handleUploadSelectedPages = async (pages: string[]) => {
    if (!pages || pages.length === 0) {
      console.warn("handleUploadSelectedPages called with empty pages:", pages);
      return;
    }
    setProgress(1);
    const totalPages = pages.length;
    setLoadingCard(totalPages);
    let processedPages = 0;

    for (const pageUrl of pages) {
      const pageData = pdfPages.find((p) => p.url === pageUrl);
      if (pageData) {
        try {
          const fileNameMain = `${pageData.name.replace(" ", "-")}-${Date.now()}`;
          const fileName = `${order.id}/${fileNameMain}.pdf`;
          const thumbnailFileName = `${order.id}/${fileNameMain}-thumbnail.png`;

          simulateProgressiveUpload(fileNameMain);

          // NEU: Original PDF-Blob hochladen (nicht das Canvas-Bild!)
          await Storage.put(fileName, pageData.originalPdfBlob, {
            contentType: "application/pdf",
          });

          updateImageProgress(fileNameMain, 100);
          setThumbnailGenerating(true);

          // Thumbnail aus dem Canvas-URL erstellen
          const thumbnailResponse = await fetch(pageData.url);
          const fullSizeBlob = await thumbnailResponse.blob();
          const lowResBlob = await createLowResolutionBlob(fullSizeBlob);

          await Storage.put(thumbnailFileName, lowResBlob, {
            contentType: "image/png",
          });

          setThumbnailGenerating(false);

          const positionImage = {
            key: fileName,
            thumbnail: thumbnailFileName,
            quantity: 1,
          };

          const updatedOrder = await onComplete(positionImage, index);
          if (updatedOrder) {
            mutate(updatedOrder);
            await fetchImage();
          }

          processedPages++;
          setLoadingCard((prev) => prev - 1);
          toast.success(`${fileName.split("/").pop()} uploaded successfully.`);
        } catch (error) {
          toast.error(`Failed to upload ${pageData.name}.`);
          console.error("File upload error:", error);
        }
      }
    }

    setPageSelectionModalVisible(false);
    setTimeout(() => setProgress(100), 500);
    setTimeout(() => setProgress(null), 1000);
  };

  const simulateProgressiveUpload = (fileNameMain: string) => {
    let progress = 0;
    const interval = setInterval(() => {
      progress += Math.random() * 10;
      if (progress > 90) {
        clearInterval(interval);
        return;
      }
      updateImageProgress(fileNameMain, Math.min(Math.round(progress), 90));
    }, 500);

    // Clear interval after 10 seconds to prevent it from running indefinitely
    setTimeout(() => clearInterval(interval), 10000);
  };

  const updateImageProgress = (fileNameMain: string, progress: number) => {
    setImageProgress((prev) => ({ ...prev, [fileNameMain]: progress }));
  };


  // Neue Funktion zum Erstellen einer echten Single-Page PDF
  const extractSinglePagePdf = async (originalFile: File, pageIndex: number): Promise<Blob> => {
    const arrayBuffer = await originalFile.arrayBuffer();
    const pdfDoc = await PDFDocument.load(arrayBuffer);

    // Neues PDF-Dokument erstellen
    const newPdfDoc = await PDFDocument.create();

    // Seite kopieren (behält alle Metadaten, Vektoren, Fonts etc.)
    const [copiedPage] = await newPdfDoc.copyPages(pdfDoc, [pageIndex]);
    newPdfDoc.addPage(copiedPage);

    // Als Blob zurückgeben
    const pdfBytes = await newPdfDoc.save();
    return new Blob([pdfBytes], { type: 'application/pdf' });
  };
  // Modifizierte splitPdf Funktion
  const splitPdf = async (file: File) => {
    setPdfProgress(1);
    const pdf = await pdfjsLib.getDocument(URL.createObjectURL(file)).promise;
    const pageCount = pdf.numPages;

    const pages: {
      name: string;
      dimensions: string;
      url: string;              // Thumbnail URL (Canvas DataURL)
      fileName: string;
      fileSize: string;
      originalPdfBlob: Blob;    // NEU: Die echte PDF-Seite als Blob
      pageIndex: number;        // NEU: Index für spätere Referenz
    }[] = [];

    if (pageCount === 1) {
      setNumPages(pageCount);
      return { pageCount, pages };
    }

    for (let i = 1; i <= pageCount; i++) {
      const page = await pdf.getPage(i);
      const viewport = page.getViewport({ scale: 2 });

      // Thumbnail erstellen (wie bisher)
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d")!;
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      await page.render({ canvasContext: context, viewport }).promise;
      const thumbnailUrl = canvas.toDataURL();

      // NEU: Echte PDF-Seite extrahieren
      const originalPdfBlob = await extractSinglePagePdf(file, i - 1);

      // Original-Dimensionen aus der PDF-Seite holen (in Points, 1 point = 0.3528mm)
      const originalViewport = page.getViewport({ scale: 1 });
      const widthMm = (originalViewport.width * 0.3528).toFixed(2);
      const heightMm = (originalViewport.height * 0.3528).toFixed(2);

      pages.push({
        name: `Page ${i}`,
        dimensions: `${widthMm} x ${heightMm} mm`,
        url: thumbnailUrl,
        fileName: file.name,
        fileSize: (originalPdfBlob.size / 1024 / 1024).toFixed(2) + " MB",
        originalPdfBlob,         // NEU
        pageIndex: i - 1,        // NEU
      });

      setPdfProgress(Math.round((i / pageCount) * 100));
    }

    setNumPages(pageCount);
    return { pageCount, pages };
  };

  return (
    <div className={`position-item ${open ? "opened" : ""}`}>
      {galleryImage && (
        <ImageGallery
          image={galleryImage}
          outline={outline}
          onClose={() => setGalleryImage(null)}
        />
      )}
      {pdfProgress && (
        <div className="progress-layer">
          {" "}
          <RingProgress
            size={320}
            thickness={12}
            roundCaps
            className="custom-progress"
            sections={[{ value: pdfProgress, color: "blue" }]}
            label={
              <div className="progress-value">
                {t('preparingFiles')}
                <span>{`${pdfProgress}%`}</span>
              </div>
            }
          />
        </div>
      )}

      <div
        className={`position-item__header ${item.White ? "white" : ""}`}
        onClick={() => !item.White && setOpen(!open)}
      >
        <div className="header-item">
          <h2 className="text-uppercase">
            {index + 1}. {item.articleName}
          </h2>
          <h2 className="color-grey">{item.articleNumber}</h2>
        </div>
        <div className="header-item">
          <h2>
            {item.widthByMm} x {item.heightByMm}
          </h2>
        </div>
        <div className="flex flex-row">
          <h2 style={{ color: getRemainingColor(item) }}>
            {item.quantity - Number(getRemainingCount(item))}
          </h2>
          <h2>/{item.quantity}</h2>
        </div>

        <div className="header-item pointer-events-auto">
          <ArrowIcon hide={item.White} />
        </div>
      </div>
      <div
        className={`position-item__body custom${index + 1}  flex items-center`}
      >
        {!send && !item.White && (
          <div className="">
            <Upload
              handleUpload={(event) => onInputChange(event, index)}
              item={item}
              images={images}
              disabled={disabled}
            />
          </div>
        )}

        {images.map((positionItem, imageIndex) => {
          const { key, thumbnail, quantity, approvalStatus } = positionItem;
          const sum = images.reduce(
            (acc: number, curr: PositionImage) => acc + curr.quantity,
            0
          );

          const image = signedUrls[thumbnail];
          return (
            <div
              className="bg-white h-fit rounded-xl shadow-md border border-gray-200 p-4 transition-all hover:shadow-lg"
              key={positionItem.key || imageIndex}
            >
              <div
                key={imageIndex.toString()}
                className="upload-item bg-white rounded-lg overflow-hidden border border-gray-100 hover:border-gray-300 transition-shadow 
         flex flex-col items-center gap-2 pt-2 pb-3"
                onClick={(e: any) => {
                  if (
                    JSON.stringify(e.target.classList) ===
                    JSON.stringify({ "0": "upload-item" }) &&
                    (approvalStatus === ApprovalStatus.Yes ||
                      approvalStatus === ApprovalStatus.No)
                  ) {
                    setCurrent(positionItem);
                  }
                }}
                style={{
                  cursor:
                    approvalStatus === ApprovalStatus.Yes ||
                      approvalStatus === ApprovalStatus.No
                      ? "pointer"
                      : "default",
                  border:
                    approvalStatus === ApprovalStatus.Yes
                      ? "3px solid #34C759"
                      : approvalStatus === ApprovalStatus.No
                        ? "3px solid crimson"
                        : 0,
                }}
              >
                {/* Thumbnail exakt 180x180 */}
                <div className="relative w-[180px] h-[180px] rounded-md overflow-hidden shadow-sm">
                  <img
                    src={image}
                    className="w-full h-full object-cover"
                  />
                  <RenderBackgroundLoader src={image} loading={uploading} />
                </div>

                {!send && (
                  <div className="upload-item__header flex justify-between items-center w-full px-3 mt-2">
                    <div className="item-quantity flex items-center gap-2 font-medium">
                      {t("quantity")} {quantity}
                      <div
                        className={`item-quantity__quantity-btns flex flex-col bg-gray-100 rounded-md p-1 shadow-sm ${disabled ? "opacity-40 pointer-events-none" : "hover:bg-gray-200"
                          }`}
                      >
                        <CaretUpIcon
                          color={sum < item.quantity ? "#333" : null}
                          handleClick={() => {
                            if (sum < item.quantity) {
                              const updatedImages = images.map((img, idx) =>
                                idx === imageIndex
                                  ? { ...img, quantity: img.quantity + 1 }
                                  : img
                              );
                              setImages(updatedImages);
                              const positions = order.positions.map((position, posIndex) => {
                                if (
                                  position.articleNumber === item.articleNumber &&
                                  position.heightByMm === item.heightByMm &&
                                  position.widthByMm === item.widthByMm &&
                                  posIndex === index
                                ) {
                                  return {
                                    ...position,
                                    positionImage: updatedImages,
                                  };
                                }
                                return {
                                  ...position,
                                  positionImage: position.positionImage
                                    ? position.positionImage
                                    : [],
                                };
                              });
                              toast.success(t("quantityUpdated"));
                              handleOrderUpdate({ id: order.id, positions });
                              mutate({ ...order, positions });
                              if (onImagesChange) onImagesChange(updatedImages, index);
                            }
                          }}
                        />
                        <CaretDownIcon
                          color={quantity > 1 ? "#333" : null}
                          handleClick={() => {
                            if (quantity > 1) {
                              const updatedImages = images.map((img, idx) =>
                                idx === imageIndex
                                  ? { ...img, quantity: img.quantity - 1 }
                                  : img
                              );
                              setImages(updatedImages);
                              const positions = order.positions.map((position, posIndex) => {
                                if (
                                  position.articleNumber === item.articleNumber &&
                                  position.heightByMm === item.heightByMm &&
                                  position.widthByMm === item.widthByMm &&
                                  posIndex === index
                                ) {
                                  return {
                                    ...position,
                                    positionImage: updatedImages,
                                  };
                                }
                                return {
                                  ...position,
                                  positionImage: position.positionImage
                                    ? position.positionImage
                                    : [],
                                };
                              });
                              toast.success(t("quantityUpdated"));
                              handleOrderUpdate({ id: order.id, positions });
                              mutate({ ...order, positions });
                              if (onImagesChange) onImagesChange(updatedImages, index);
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div
                      onClick={() => {
                        const updatedImages = images.filter((_, idx) => idx !== index);
                        setImages(updatedImages);
                        const positions = order.positions.map((position) => {
                          let newPositionImage = [];
                          position?.positionImage?.map((imageItem) => {
                            if (imageItem.key != key) newPositionImage.push(imageItem);
                          });
                          return { ...position, positionImage: newPositionImage };
                        });
                        toast.success(t("positionImageRemoved"));
                        handleOrderUpdate({ id: order.id, positions });
                        mutate({ ...order, positions });
                        Storage.remove(key);
                        Storage.remove(thumbnail);
                      }}
                      className={`item-remove text-gray-500 hover:text-red-500 transition-colors ${disabled && "opacity-30 pointer-events-none"
                        }`}
                    >
                      <XMarkIcon />
                    </div>
                  </div>
                )}
              </div>

              {/* Dateiname */}
              <div className="flex flex-col space-y-1 justify-center items-center my-2 w-full">
                <p className="text-[14px]! leading-snug! text-gray-600 text-center 
          px-2 py-1 bg-gray-50 rounded-md shadow-sm 
          whitespace-nowrap overflow-hidden text-ellipsis w-[180px]">
                  {positionItem?.key.split("/").pop()}
                </p>
              </div>

              {/* Warning Button AUSSERHALB der Card */}
              {!send && approvalStatus === ApprovalStatus.No && (
                <button
                  className={`w-full flex items-center justify-center gap-2.5 text-sm font-semibold px-4 py-3 rounded-lg bg-red-600 text-white shadow-md hover:bg-red-700 hover:shadow-lg transition-all duration-150 border border-red-700 mt-2 ${disabled && "opacity-40 pointer-events-none cursor-not-allowed"
                    }`}
                  onClick={() => {
                    setCurrent(positionItem);
                    setModalApproveVisible(true);
                  }}
                  disabled={disabled}
                >
                  <WarningIcon color="white" size={18} />
                  <span>{t("Warning")}</span>
                </button>
              )}
            </div>
          );
        })}
        {singlePdfProgress && (
          <div key={index} className="loading-card">
            <div className="loading-card-header">
              <button>
                <svg
                  width="12"
                  height="19"
                  viewBox="0 0 12 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_102_40)">
                    <path
                      d="M11.6475 13.4113C12.1162 13.8752 12.1162 14.6267 11.6475 15.0905C11.415 15.3225 11.1075 15.4375 10.8 15.4375C10.4925 15.4375 10.1858 15.3215 9.95175 15.0896L6 11.1811L2.04862 15.0887C1.81425 15.3225 1.50712 15.4375 1.2 15.4375C0.892875 15.4375 0.586125 15.3225 0.351562 15.0887C-0.117187 14.6248 -0.117187 13.8733 0.351562 13.4095L4.30406 9.49814L0.351562 5.58867C-0.117187 5.1248 -0.117187 4.37334 0.351562 3.90947C0.820312 3.4456 1.57969 3.4456 2.04844 3.90947L6 7.82265L9.9525 3.91133C10.4212 3.44746 11.1806 3.44746 11.6494 3.91133C12.1181 4.37519 12.1181 5.12666 11.6494 5.59052L7.69687 9.50185L11.6475 13.4113Z"
                      fill="black"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_102_40">
                      <rect width="12" height="19" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
            <div className="loading-card-body">
              {" "}
              <div className="inner-loader">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
              <p>Thumbnail is being generated</p>
            </div>

            <div className="loading-card-footer">
              <div className="footer-wrap">
                <div
                  className="image-progress-bar"
                  style={{ width: `${singlePdfProgress}%` }}
                ></div>
                <h1>{singlePdfProgress ?? 0}%</h1>
              </div>
            </div>
          </div>
        )}
        {singleProgress && (
          <div key={index} className="loading-card">
            <div className="loading-card-header">
              <button>
                <svg
                  width="12"
                  height="19"
                  viewBox="0 0 12 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_102_40)">
                    <path
                      d="M11.6475 13.4113C12.1162 13.8752 12.1162 14.6267 11.6475 15.0905C11.415 15.3225 11.1075 15.4375 10.8 15.4375C10.4925 15.4375 10.1858 15.3215 9.95175 15.0896L6 11.1811L2.04862 15.0887C1.81425 15.3225 1.50712 15.4375 1.2 15.4375C0.892875 15.4375 0.586125 15.3225 0.351562 15.0887C-0.117187 14.6248 -0.117187 13.8733 0.351562 13.4095L4.30406 9.49814L0.351562 5.58867C-0.117187 5.1248 -0.117187 4.37334 0.351562 3.90947C0.820312 3.4456 1.57969 3.4456 2.04844 3.90947L6 7.82265L9.9525 3.91133C10.4212 3.44746 11.1806 3.44746 11.6494 3.91133C12.1181 4.37519 12.1181 5.12666 11.6494 5.59052L7.69687 9.50185L11.6475 13.4113Z"
                      fill="black"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_102_40">
                      <rect width="12" height="19" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
            <div className="loading-card-body">
              {" "}
              <div className="inner-loader">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
              <p>Thumbnail is being generated</p>
            </div>

            <div className="loading-card-footer">
              <div className="footer-wrap">
                <div
                  className="image-progress-bar"
                  style={{ width: `${singleProgress}%` }}
                ></div>
                <h1>{singleProgress ?? 0}%</h1>
              </div>
            </div>
          </div>
        )}
        {progress && loadingCard > 0 && (
          <div key={index} className="loading-card">
            <div className="loading-card-header">
              <button>
                <svg
                  width="12"
                  height="19"
                  viewBox="0 0 12 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_102_40)">
                    <path
                      d="M11.6475 13.4113C12.1162 13.8752 12.1162 14.6267 11.6475 15.0905C11.415 15.3225 11.1075 15.4375 10.8 15.4375C10.4925 15.4375 10.1858 15.3215 9.95175 15.0896L6 11.1811L2.04862 15.0887C1.81425 15.3225 1.50712 15.4375 1.2 15.4375C0.892875 15.4375 0.586125 15.3225 0.351562 15.0887C-0.117187 14.6248 -0.117187 13.8733 0.351562 13.4095L4.30406 9.49814L0.351562 5.58867C-0.117187 5.1248 -0.117187 4.37334 0.351562 3.90947C0.820312 3.4456 1.57969 3.4456 2.04844 3.90947L6 7.82265L9.9525 3.91133C10.4212 3.44746 11.1806 3.44746 11.6494 3.91133C12.1181 4.37519 12.1181 5.12666 11.6494 5.59052L7.69687 9.50185L11.6475 13.4113Z"
                      fill="black"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_102_40">
                      <rect width="12" height="19" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
            <div className="loading-card-body">
              {" "}
              <div className="inner-loader">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
              <p>Thumbnail is being generated</p>
            </div>

            <div className="loading-card-footer">
              <div className="footer-wrap">
                <div
                  className="image-progress-bar"
                  style={{ width: `${imageProgress?.progress}%` }}
                ></div>
                <h1>{imageProgress?.progress ?? 0}%</h1>
              </div>
            </div>
          </div>
        )}
        {progress && loadingCard > 0 && (
          <>
            {Array.from({ length: loadingCard })
              .slice(0, -1)
              .map((_, index) => (
                <div key={index} className="loading-card">
                  <div className="loading-card-header">
                    <button>
                      <svg
                        width="12"
                        height="19"
                        viewBox="0 0 12 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_102_40)">
                          <path
                            d="M11.6475 13.4113C12.1162 13.8752 12.1162 14.6267 11.6475 15.0905C11.415 15.3225 11.1075 15.4375 10.8 15.4375C10.4925 15.4375 10.1858 15.3215 9.95175 15.0896L6 11.1811L2.04862 15.0887C1.81425 15.3225 1.50712 15.4375 1.2 15.4375C0.892875 15.4375 0.586125 15.3225 0.351562 15.0887C-0.117187 14.6248 -0.117187 13.8733 0.351562 13.4095L4.30406 9.49814L0.351562 5.58867C-0.117187 5.1248 -0.117187 4.37334 0.351562 3.90947C0.820312 3.4456 1.57969 3.4456 2.04844 3.90947L6 7.82265L9.9525 3.91133C10.4212 3.44746 11.1806 3.44746 11.6494 3.91133C12.1181 4.37519 12.1181 5.12666 11.6494 5.59052L7.69687 9.50185L11.6475 13.4113Z"
                            fill="black"
                          ></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_102_40">
                            <rect width="12" height="19" fill="white"></rect>
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                  </div>
                  <div className="loading-card-body">
                    {" "}
                    <div className="inner-loader">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <p>Thumbnail is being generated</p>
                  </div>

                  <div className="loading-card-footer">
                    <div className="footer-wrap">
                      <div
                        className="image-progress-bar"
                        style={{ width: "0%" }}
                      ></div>
                      <h1>0%</h1>
                    </div>
                  </div>
                </div>
              ))}
          </>
        )}

        <input
          accept=".png, .jpeg, .jpg, .pdf, .epub"
          style={{ display: "none" }}
          ref={inputRef}
          type="file"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            if (e.target.files) {
              onInputChange(e.target.files, index);
            }
          }}
        />
      </div>

      <Modal compact visible={modalVisible} onClose={onModalClose}>
        {current && !base64 ? (
          <>
            <div className="modal-preview">
              <div className="image-wrapper">
                {outline && (
                  <div className="image-wrapper__info">
                    <div className="marker-line" />
                    <Text color="#fa00ff" weight={700}>
                      {t("cutting")}
                    </Text>
                  </div>
                )}
                <div className="image-container">
                  <ImageOutline outline={outline} />
                  <img
                    style={{
                      minHeight: "auto",
                      visibility: url ? "visible" : "hidden",
                      display: type === "image" && url ? "block" : "none",
                    }}
                    src={url || ""}
                    id={`image-preview_${index}`}
                    className="image-preview"
                    onLoad={onImageLoad}
                    alt=""
                    onClick={() => galleryPreview()}
                  />
                </div>
              </div>
              {type === "image" ? (
                <>{!url && <Loader />}</>
              ) : type === "pdf" ? (
                <>
                  {url ? (
                    <PdfPreview
                      item={item}
                      url={url}
                      outline={outline}
                      setPdfData={setPdfKey}
                      previewPdf={galleryPreview}
                      setOutline={setOutline}
                    />
                  ) : (
                    <Loader />
                  )}
                </>
              ) : (
                <Loader />
              )}
              {type === "image" && url && (
                <>
                  <div
                    onClick={() => galleryPreview()}
                    className="image-action"
                  >
                    <span>{t("imageFullScreen")}</span>
                    <ZoomInOutlined style={{ fontSize: 28, marginLeft: 5 }} />
                  </div>
                  <span className="text-small">
                    {t("imagePreviewDescription")}
                  </span>
                </>
              )}
            </div>
            <div className="modal-info">
              <ImageDetail
                numPages={numPages}
                productRatio={getRatio(item.widthByMm, item.heightByMm)}
              />
            </div>
          </>
        ) : (
          <>
            <div className="modal-preview">
              <div className="image-wrapper">
                {outline && type === "image" && (
                  <div className="image-wrapper__info">
                    <div className="marker-line" />
                    <Text color="#fa00ff" weight={700}>
                      {t("cutting")}
                    </Text>
                  </div>
                )}
                <div className="image-container">
                  <ImageOutline outline={outline} />
                  <img
                    style={{
                      minHeight: "auto",
                      visibility: base64 ? "visible" : "hidden",
                      display:
                        type === "image" && ratio?.fit ? "block" : "none",
                      maxHeight: type === "image" && ratio?.fit ? "400px" : "0",
                    }}
                    id={`image-preview_${index}`}
                    className="image-preview"
                    onLoad={onImageLoad}
                    alt=""
                    onClick={() => galleryPreview()}
                  />
                </div>
              </div>
              {base64 ? (
                <>
                  {type === "pdf" && (
                    <PdfPreview
                      item={item}
                      image={new File([], "")}
                      base64={base64}
                      url={base64 || URL.createObjectURL(new File([], ""))}
                      outline={outline}
                      setPdfData={setPdfKey}
                      previewPdf={galleryPreview}
                      setOutline={setOutline}
                    />
                  )}
                  {ratio && !ratio?.fit && (
                    <div className="row row-center">
                      {(numPages == 1 && type === "pdf") || type != "pdf" ? (
                        <span className="text-center" style={{ fontSize: 18 }}>
                          {t("imageDoesNotMatch")}
                        </span>
                      ) : (
                        <div className="modal-preview">
                          <img
                            style={{
                              width: "100%",
                              maxWidth: "200px",
                              height: "auto",
                            }}
                            src=""
                            alt=""
                          />
                          <p>
                            <br />
                            <br />
                            Sie haben eine mehrseite PDF hochgeladen. Bitte
                            teilen Sie die PDF in einzelne Datein auf. <br />
                            <br />
                            Dazu können Sie z.B.{" "}
                            <a
                              target="blank"
                              href="https://www.ilovepdf.com/de/pdf_teilen#split,range"
                            >
                              dieses{" "}
                            </a>
                            kostenlose Tool nutzen.
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <>{type === "image" ? <ImagePreviewLoading /> : <Loader />}</>
              )}
              {type === "image" && ratio && ratio?.fit && (
                <>
                  <div
                    onClick={() => galleryPreview()}
                    className="image-action"
                  >
                    <span>{t("imageFullScreen")}</span>
                    <ZoomInOutlined style={{ fontSize: 28, marginLeft: 5 }} />
                  </div>
                  <span className="text-small">
                    {t("imagePreviewDescription")}
                  </span>
                </>
              )}
            </div>

            {(numPages == 1 && type === "pdf") || type != "pdf" ? (
              <div className="modal-info">
                <ImageDetail
                  ratio={ratio}
                  numPages={numPages}
                  productRatio={getRatio(item.widthByMm, item.heightByMm)}
                />
                <div
                  className="choose-another-file"
                  style={{ pointerEvents: !!uploadStatus ? "none" : "unset" }}
                >
                  <span onClick={handleUpload}>
                    <span>{t("chooseAnotherFile")} </span>
                    <Upload
                      handleUpload={(event) => onInputChange(event, index)}
                      item={item}
                      images={images}
                      disabled={disabled}
                    />
                  </span>
                </div>
                {numPages !== 1 && (
                  <SendPrintdata
                    uploadStatus={uploadStatus}
                    approved={approved}
                    setApproved={setApproved}
                    image={new File([], "")}
                    handleS3Upload={() => { }}
                    isLarge={isLarge}
                  />
                )}
              </div>
            ) : null}
          </>
        )}
      </Modal>

      <PageSelectionModal
        visible={pageSelectionModalVisible}
        pages={pdfPages}
        selectedPages={selectedPages}
        position={{
          position: index + 1,
          width: item.widthByMm,
          height: item.heightByMm,
        }}
        onClose={() => setPageSelectionModalVisible(false)}
        onUpload={handleUploadSelectedPages}
        remaining={Number(getRemainingCount(item))}
      />

      <Modal
        compact
        center
        visible={modalApproveVisible}
        onClose={onModalApproveClose}
      >
        {current && (
          <>
            {current.approvalStatus === ApprovalStatus.Yes && (
              <RenderApproveView current={current} />
            )}
            {current.approvalStatus === ApprovalStatus.No && (
              <RenderDontApproveView
                current={current}
                order={order}
                item={item}
                callback={grantReleaseCallback}
              />
            )}
          </>
        )}
      </Modal>
    </div>
  );
};

export default PositionItem;